module.exports = __webpack_public_path__ + "img/teaching-5.fc94288d.png";